import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../../assets/lottie-animations/agent-lottie.json';

export const AgentAnimation = ({open = true, loop = true, autoplay = true, ...props}) => {
  const defaultOptions = {
    loop: loop,
    autoplay: autoplay,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    },
  };

  return (
    open && <Lottie
        options={defaultOptions}
        height={260}
        width={260}
        {...props}
      />
  );
};
